"use strict";

// configuration
var ubian = ubian || {};
function cardProductsTransfer() {
    var snr = $("#prenos-VIK-btn").data("snr");
    if(snr != undefined) {
        $.post(ubian.routes["card-products-transfer"], {"snr": snr})
            .done(function(res) {
                if(res.errorCode) {
                    ubian.utils.alert(ubian.translate("APIError." + res.errorCode));
                }
                else {
                    ubian.utils.alert(ubian.translate("Card.Virtualize.End.AllowTransferBack.Alert.Success.Text"));
                }
            })
            .fail(function (err) {
                ubian.utils.alert("Error : " + err);
            });
    }
}
$(function () {
   $("#prenos-VIK-btn").click(function () {
      ubian.utils.alert(
          ubian.translate("Card.Virtualize.End.AllowTransferBack.Alert.Text"),
          "",
          ubian.translate("Card.Virtualize.End.AllowTransferBack.Alert.Button"),
          cardProductsTransfer,
          false);
   });
});